var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM12.0146 4.9541C11.7133 4.66997 11.2382 4.68398 10.9541 4.98535L6.78223 9.40918L5.04297 7.58301C4.7573 7.28306 4.28237 7.27098 3.98242 7.55664C3.68252 7.84231 3.67138 8.31726 3.95703 8.61719L6.24219 11.0176C6.38408 11.1666 6.58137 11.2504 6.78711 11.25C6.99291 11.2495 7.18981 11.1643 7.33105 11.0146L12.0459 6.01465C12.33 5.71327 12.316 5.23825 12.0146 4.9541Z",
    fill: "#430A9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/CheckCircleIcon.b73b366bc2ec839df1f646307f922a42.svg";
export { ForwardRef as ReactComponent };